const carRental = {
  carRental: "レンタカー", // translated
  carRentals: "レンタカー", // translated
  pickUpPoint: "乗車地", // translated
  dropOffPoint: "降車地点", // translated
  pickUpDate: "受取日", // translated
  dropOffDate: "返却日", // translated
  pickUp: "選び出す", // translated
  dropOff: "落ちる", // translated
  edit: "編集", // translated
  fuelPolicy: "燃料ポリシー", // translated
  pickUpLocation: "受け取り場所", // translated
  mileage: "マイレージ", // translated
  transmission: "伝染 ; 感染", // translated
  airCondition: "エアコン", // translated
  minimumAge: "最低年齢", // translated
  maximumAge: "最大年齢", // translated
  providerAddress: "プロバイダーアドレス", // translated
  providerPhone: "プロバイダーの電話", // translated
  driverInfo: "ドライバー情報", // translated
  driversInfo: "ドライバーの情報", // translated
  differentDropOff: "別の場所で降車", // translated
  maxPassengers: "最大乗客数", // translated
  budget: "予算", // translated
  provider: "プロバイダー", // translated
  carModel: "車のモデル", // translated
  numOfDoors: "ドアの数", // translated
  fuelType: "燃料のタイプ", // translated
  driverAge: "年齢", // translated
  workingHours: "労働時間", // translated
  driverNationality: "ドライバーの国籍", // translated
  carRentalRate: "レンタカー料金", // translated
  dueNow: "今すぐ期限", // translated
  duePickUp: "受け取り時に期限", // translated
  toViewOfferPDF:
    "このオファーのすべてのレンタル条件を含む PDF ドキュメントを表示するには、次のリンクをクリックしてください。", // translated
  toViewTermsAndCondPDF:
    "該当する CARNECT 利用規約を確認するには、次の URL を参照してください。", // translated
  enterValidDriversAge: "受取日を入力してください", // translated
  nationalityIsRequired: "受取日より後の返却日を入力してください", // translated
  pleaseSelectAPickUpPoint: "乗車地を入力してください", // translated
  carRentalsNotFound:
    "申し訳ありませんが、お希望の日程でレンタカーをご利用いただけません", // translated
};

export default carRental;
